import React, { useState, useEffect, useRef } from "react";
import { firestore } from "../../firebase/config";
import {
  collection,
  doc,
  endBefore,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import styles from "./chat.module.css"; // Import your CSS module
import { AiOutlineSend } from "react-icons/ai";
import { BsCameraVideo } from "react-icons/bs";
import { IoIosSend , IoMdAttach } from "react-icons/io";
import { LoadingOutlined } from "@ant-design/icons";
import { Popover, Spin } from "antd";
import { FaCalendarAlt, FaHandshake } from "react-icons/fa";
import {
  addDocToFirestore,
  formatMessage,
  getFormatedMessageTime,
  getFormattedTime,
  getGreaterID,
  getLesserID,
  makeLinksClickable,
  reactToast,
} from "../../helper";
import { toast } from "react-toastify";
import { createCustomMeeting, createMeeting } from "../../services/zoom-meetings";
import { useSelector } from "react-redux";
import {
  DEMO_TYPE,
  MEETING_PERIOD,
  MESSAGE_TYPES,
  MONTHLY_TYPE,
  STUDENT_ROLE,
  TEACHER_ROLE,
  offerStatuses,
} from "../../constants";
import { StudentOfferCard } from "./OfferCard";
import CreateOfferCard from "../createOfferCard/CreateOfferCard";
import { updateRequestedOfferStatus } from "../../services/offers";
import { MdOutlineKeyboardVoice } from "react-icons/md";
import { RiVoiceprintFill, RiPauseFill, RiPlayFill } from "react-icons/ri";
import { IoLocationOutline } from "react-icons/io5";
import { BiCheckDouble, BiTrash } from "react-icons/bi";
import AudioPlayer from "../audio-player";
import { UploadFile } from "../../services/uploadFiles";
import { baseUrl } from "../../services/api";
import MicRecorder from "mic-recorder-to-mp3";
import { Avatar } from "antd";
import UserProfileAvatar from '../../assets/images/avatar.jpg'
import useUserStatus from "../../helper/use-user-status";
const INITIAL_OFFER_DATA = {
  offerType: "monthly",
};

// Custom antIcon for spinner
const antIcon = <LoadingOutlined style={{ fontSize: 20, color: '#1890ff' }} spin />;

const MESSAGE_LIMIT = 10;
const Chat = ({
  receiver,
  profileImage,
  handleChatModalOpen,
  isBlocked,
  isBlockedByMe,
  isModal = true,
}) => {
  const containerClass = isModal
    ? styles.modalChatContainer
    : styles.pageChatContainer;
  const currentUser = useSelector((state) => state.auth.user);
  const receiverID = receiver?.receiver_uuid === currentUser?.uuid
                ? receiver?.sender_uuid
                : receiver?.receiver_uuid;
  const activeStatus = useUserStatus(receiverID);
  // console.log("reciever", receiver);
  const [init, setInit] = useState(false);
  const [messages, setMessages] = useState([]);
  const [offerDetail, setOfferDetail] = useState({
    ...INITIAL_OFFER_DATA,
  });
  const [random, setRandom] = useState([0, ""]);
  const [loading, setLoading] = useState(false);
  const [offerStatusLoading, setOfferStatusLoading] = useState(false);
  const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [meetingLoading, setMeeingLoading] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [openOfferCard, setOpenOfferCard] = useState(false);

  const messagesEndRef = useRef(null);
  const messagesAreaRef = useRef(null);
  const inputRef = useRef(null);

  const [recorder, setRecorder] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [duration, setDuration] = useState(0);
  const [recordingBlobs, setRecordingBlobs] = useState([]);
  const mediaRecorderRef = useRef(null);
  const audioStreamRef = useRef(null);
  const [offerPopupVisible, setOfferPopupVisible] = useState(false);

  // Initialize recorder in useEffect
  useEffect(() => {
    try {
      const micRecorder = new MicRecorder({ bitRate: 128 });
      setRecorder(micRecorder);
    } catch (error) {
      console.error("Error initializing recorder:", error);
    }
  }, []);

  useEffect(() => {
    // random[1] && getNewMessages(random[1]);
  }, [random]);

  useEffect(() => {
    setInitialLoading(true);
    setMessages([]);

    const chatID = `${getLesserID(
      currentUser?.uuid,
      receiver?.uuid
    )}_${getGreaterID(currentUser?.uuid, receiver?.uuid)}`;

    const chatRef = doc(firestore, `chats/${chatID}`);
    const messagesQuery = query(
      collection(chatRef, "messages"),
      orderBy("timestamp", "desc"),
      limit(MESSAGE_LIMIT)
    );

    const unsub = onSnapshot(messagesQuery, (messagesSnapshot) => {
      const updatedMessages = messagesSnapshot.docs.map((doc) => ({
        chatId: chatRef.id,
        messageId: doc.id,
        ...doc.data(),
      }));
      setMessages(updatedMessages);
      setInitialLoading(false);
    });

    return unsub;
  }, [receiver?.uuid, currentUser?.uuid]);

  useEffect(() => {
    if (messages?.length) {
      scrollToBottom();
    }
  }, [messages]);

  // useEffect(() => {
  //   inputRef.current.focus();
  // }, []);

  // Define a function to load more messages
  // new functionality to load more messages
  const loadMoreMessages = async (lmt, messages) => {
    try {
      setLoadingMoreMessages(true);

      const chatID = `${getLesserID(
        currentUser?.uuid,
        receiver?.uuid
      )}_${getGreaterID(currentUser?.uuid, receiver?.uuid)}`;

      const chatRef = doc(firestore, `chats/${chatID}`);
      const messagesCollectionRef = collection(chatRef, "messages");
      // Get the last visible message
      const lastVisibleMessage =
        messages[messages.length - 1]?.timestamp || null;
      // Query for the next batch of messages starting after the last visible message
      const nextQuery = query(
        messagesCollectionRef,
        orderBy("timestamp", "desc"),
        startAfter(lastVisibleMessage), // Start after the last message's timestamp or null
        limit(lmt)
      );
      // Get the next batch of messages
      const querySnapshot = await getDocs(nextQuery);
      // Convert the query snapshot into an array of message data
      const newMessages = querySnapshot.docs.map((doc) => doc.data());
      // Add the new messages to the existing messages array
      setMessages((prevMessages) => [...prevMessages, ...newMessages]);

      setLoadingMoreMessages(false);
    } catch (error) {
      setLoadingMoreMessages(false);
      console.error("Error loading more messages:", error);
    }
  };

  // new Funcitionality to send message
  const sendMessage = async (
    content,
    offerData = null,
    msgType,
    totalDuration
  ) => {
    try {
      if (!content || content?.trim() === "") return;
      setLoading(true);
      setNewMessage("");
      const userID = currentUser?.uuid;
      const receiverID = receiver?.uuid;
      const receiverProfileUrl = receiver?.teacherMedia?.find(
        (x) => x?.type === "profilePicture"
      )?.url;
      const localProfilePic = localStorage.getItem("profilePicture");
      const senderProfileUrl = localProfilePic || currentUser?.profilePicture;

      const commonMessageData = {
        sender_uuid: userID || "",
        senderName: currentUser?.fullName || "",
        senderId: currentUser?.id || "",
        senderRole: currentUser?.role || "",
        receiver_uuid: receiverID || "",
        receiverId: receiver?.id || "",
        receiverName: receiver?.fullName || "",
        receiverProfileUrl:
          receiver?.teacherMedia?.find((x) => x?.type === "profilePicture")
            ?.url || "",
        timestamp: new Date().toISOString(),
        seen: false,
      };
      let messageBody = {};
      // is offer type
      if (openOfferCard) {
        messageBody = {
          text: content,
          message_type: msgType || MESSAGE_TYPES.OFFER,
          offerDetail: offerData,
          ...commonMessageData,
        };
      }
      if (msgType === MESSAGE_TYPES.TEXT) {
        messageBody = {
          text: content,
          message_type: msgType,
          ...commonMessageData,
        };
      } else if (msgType === MESSAGE_TYPES.AUDIO) {
        messageBody = {
          audioUrl: content,
          message_type: msgType,
          audioDuration: totalDuration,
          ...commonMessageData,
        };
      }
      // console.log("current user", currentUser);
      // console.log("reciever", receiver);
      // console.log("msg data object", messageBody);
      // console.log("receiverProfileUrl", receiverProfileUrl);
      // console.log("senderProfileUrl", senderProfileUrl);
      //debugger;
      setMessages([messageBody, ...messages]);
      scrollToBottom();
      await addDocToFirestore(currentUser?.uuid, receiver?.uuid, messageBody, senderProfileUrl, receiverProfileUrl);
      setLoading(false);
    } catch (error) {
      toast.error("Message is not sent, try again");
      console.log("Error sending message:", error);
      setLoading(false);
    }
  };

  // offer status update functionality
  const updateOfferStatus = async (
    chatId,
    messageId,
    newOfferStatus,
    message
  ) => {
    try {
      setOfferStatusLoading(true);
      const chatRef = firestore.collection("chats").doc(chatId);
      const messageRef = chatRef.collection("messages").doc(messageId);

      let updatedOfferDetail = {
        ...message,
        offerDetail: {
          ...message.offerDetail,
          offerStatus: newOfferStatus,
        },
      };

      let payload = {
        status: newOfferStatus,
      };

      const { status, data } = await updateRequestedOfferStatus(
        message?.offerDetail?.offerId,
        payload
      );
      if (status === 200) {
        await messageRef.update(updatedOfferDetail);
        // await messageRef.update({ "offerDetail.offerStatus": newOfferStatus });

        reactToast("success", data?.message);
      } else {
        reactToast("error", data?.message);
      }
      setOfferStatusLoading(false);
    } catch (error) {
      setOfferStatusLoading(false);

      console.error("Error updating offer status:", error);
    }
  };

  const startRecording = React.useCallback(async () => {
    try {
      // Reset state variables
      setRecordingBlobs([]);
      setAudioUrl(null);
      setIsPaused(false);

      // Get audio stream
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioStreamRef.current = stream;

      // Create MediaRecorder instance
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      // Handle data available event
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          setRecordingBlobs((prev) => [...prev, event.data]);
        }
      };

      // Start recording
      mediaRecorder.start(1000); // Collect data in chunks of 1000ms
      setIsRecording(true);
    } catch (error) {
      console.error("Error starting recording:", error);
      toast.error(
        "Could not start recording. Please check your microphone permissions."
      );
    }
  }, []);

  const pauseRecording = React.useCallback(() => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.pause();
      setIsPaused(true);
    }
  }, []);

  const resumeRecording = React.useCallback(() => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "paused"
    ) {
      mediaRecorderRef.current.resume();
      setIsPaused(false);
    }
  }, []);

  // New function to discard the recording
  const discardRecording = React.useCallback(() => {
    // Stop the MediaRecorder if it's running
    if (mediaRecorderRef.current) {
      if (mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
      }
      mediaRecorderRef.current = null;
    }

    // Stop all audio tracks
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }

    // Reset all related states
    setRecordingBlobs([]);
    setAudioUrl(null);
    setIsRecording(false);
    setIsPaused(false);
    setDuration(0);

    toast.info("Recording discarded");
  }, []);

  const stopRecording = React.useCallback(async () => {
    if (!mediaRecorderRef.current) {
      console.error("No active recording");
      return;
    }

    return new Promise((resolve) => {
      mediaRecorderRef.current.onstop = async () => {
        try {
          // Create a blob from all the recorded chunks
          const audioBlob = new Blob(recordingBlobs, { type: "audio/mp3" });

          // Create a URL for the blob
          const url = URL.createObjectURL(audioBlob);
          setAudioUrl(url);

          // Calculate duration properly using AudioContext
          const audioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
          const arrayBuffer = await audioBlob.arrayBuffer();
          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

          const audioDuration = audioBuffer.duration;
          setDuration(audioDuration);

          // Upload the audio file
          const formData = new FormData();
          formData.append("file", audioBlob, "recording.mp3");

          let { data } = await UploadFile(formData);
          if (data?.data?.url) {
            await sendMessage(
              data?.data?.url,
              null,
              MESSAGE_TYPES.AUDIO,
              audioDuration
            );
          } else {
            toast.error("Failed to upload audio file");
          }

          resolve();
        } catch (error) {
          console.error("Error processing recording:", error);
          toast.error("Failed to process recording");
          resolve();
        } finally {
          // Stop all audio tracks
          if (audioStreamRef.current) {
            audioStreamRef.current.getTracks().forEach((track) => track.stop());
            audioStreamRef.current = null;
          }
        }
      };

      // If recording is paused, resume it before stopping
      if (mediaRecorderRef.current.state === "paused") {
        mediaRecorderRef.current.resume();
      }

      // Stop the recording
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      setIsPaused(false);
    });
  }, [recordingBlobs]);

  const scrollToBottom = () => {
    if (messagesAreaRef.current) {
      messagesAreaRef.current.scrollTop = messagesAreaRef.current.scrollHeight;
    }
  };

  const createZoomMeeting = async () => {
    try {
      const receiverProfileUrl = receiver?.teacherMedia?.find(
        (x) => x?.type === "profilePicture"
      )?.url;
      setMeeingLoading(true);

      const body = {
        teacherUserName: currentUser?.userName,
        uuid: currentUser?.uuid,
        studentUserName: receiver?.fullName,
        duration: MEETING_PERIOD,
      };
      let { status, data } = await createCustomMeeting(body);

      /* 
      const payload = {
        offerSlotId: null,
      };
      let { status, data } = await createMeeting(payload);
      */
      if (status === 201) {
        const userID = currentUser?.uuid;
        const receiverID = receiver?.uuid;
        const messageBody = {
          text: data?.message, // for student
          // zoom_host_url: data?.data?.start_url, // for teacher
          // zoom_guest_url: data?.data?.join_url, // for student
          zoom_host_url: data?.data?.teacherJoinLink, // for teacher
          zoom_guest_url: data?.data?.studentJoinLink, // for student
          sender_uuid: userID,
          senderName: currentUser?.fullName,
          receiverId: receiver?.id,
          receiver_uuid: receiverID,
          receiverName: receiver?.fullName,
          timestamp: new Date().toISOString(),
          senderId: currentUser?.id,
          seen: false,
        };
        const localProfilePic = localStorage.getItem("profilePicture");
        const senderProfileUrl = localProfilePic || currentUser?.profilePicture;
        debugger;
        await addDocToFirestore(currentUser?.uuid, receiver?.uuid, messageBody, senderProfileUrl, receiverProfileUrl);
        scrollToBottom();
      } else {
        reactToast("error", "Something went wrong!");
      }
      setMeeingLoading(false);
    } catch (error) {
      toast.error("Something went wrong!");
      setMeeingLoading(false);
    }
  };

  const handleCreateOfferCardModal = (offerType) => {
    setOpenOfferCard(!openOfferCard);
    if (offerType) {
      setOfferDetail({ ...INITIAL_OFFER_DATA, offerType });
    } else {
      setOfferDetail({ ...INITIAL_OFFER_DATA });
    }
  };

  const sendOffer = async (offerData) => {
    try {
      await sendMessage("New Offer Request", {
        ...offerData,
        offerStatus: offerStatuses.PENDING,
      });
      if (openOfferCard) {
        handleCreateOfferCardModal(MONTHLY_TYPE);
      }
    } catch (error) {}
  };

  const checkZoomUrl = (message) => {
    let hasZoomGuestUrl;

    if (currentUser?.role === TEACHER_ROLE) {
      if (message?.zoom_host_url) {
        hasZoomGuestUrl = message.zoom_host_url;
      } else {
        hasZoomGuestUrl = message.text;
      }
    } else if (currentUser?.role === STUDENT_ROLE) {
      if (message?.zoom_guest_url) {
        hasZoomGuestUrl = message.zoom_guest_url;
      } else {
        hasZoomGuestUrl = message.text;
      }
    } else {
      hasZoomGuestUrl = message.text;
    }
    return hasZoomGuestUrl;
  };

  const getTeacherId = () => {
    // If current user is teacher, return their ID
    if (currentUser?.role === TEACHER_ROLE) {
      return currentUser.id;
    }
    // If current user is student, find teacher ID from conversation
    const lastMessage = receiver?.lastMessage;
    if (!lastMessage) {
      return receiver?.id; // Fallback
    }
    // If student received last message, sender is teacher
    if (lastMessage.receiverId === currentUser?.id) {
      return lastMessage.senderId;
    }
    // If student sent last message, receiver is teacher
    if (lastMessage.senderId === currentUser?.id) {
      return lastMessage.receiverId;
    }
    return receiver?.id; // fallback
  };

  const offerContent = (
    <div className={styles.offerPopupContent}>
      <div
        className={styles.offerPopupItem}
        onClick={() => {
          handleCreateOfferCardModal(MONTHLY_TYPE);
          setOfferPopupVisible(false);
        }}
      >
        <FaHandshake className={styles.offerIcon} />
        Create Offer
      </div>
      <div
        className={styles.offerPopupItem}
        onClick={() => {
          handleCreateOfferCardModal(DEMO_TYPE);
          setOfferPopupVisible(false);
        }}
      >
        <FaCalendarAlt className={styles.offerIcon} />
        Instant Demo
      </div>
    </div>
  );

  const renderBlockMessage = () => {
    if (isBlockedByMe) {
      return (
        <div className={styles.blockMessage}>
          <p>You have blocked this user. Unblock to send messages.</p>
        </div>
      );
    } else if (isBlocked) {
      return (
        <div className={styles.blockMessage}>
          <p>You can't reply to this conversation.</p>
        </div>
      );
    }
  };

  const renderLoginMessage = () => {
    return (
      <div className={styles.blockMessage}>
        <p>Please login to send a message.</p>
      </div>
    );
  };

  let profilePictureUrl =
    receiver.receiver_uuid === currentUser?.uuid
      ? `${baseUrl}/${receiver.senderProfileUrl}`
      : `${baseUrl}/${receiver.receiverProfileUrl}`;
      profilePictureUrl.includes("undefined") && (profilePictureUrl = profileImage || UserProfileAvatar);

  const getReceiverAvatar = (receiver, baseUrl) => {
    profilePictureUrl =
      receiver.receiver_uuid === currentUser?.uuid
        ? `${baseUrl}/${receiver.senderProfileUrl}`
        : `${baseUrl}/${receiver.receiverProfileUrl}`;

    if (profilePictureUrl.includes("undefined")) {
      return receiver?.profileImage || UserProfileAvatar;
    }
    return profilePictureUrl;
  };

  return (
    <div className={containerClass}>
      {/* Chat Header */}
      <div className={styles.chatHeader}>
        <div className={styles.chatHeaderInfo}>
          <div className={styles.avatarContainer}>
            <Avatar src={profilePictureUrl} size={55} />
            <div
              className={`${styles.teacherOnlineStatus} ${
                activeStatus === "online" ? styles.online : styles.offline
              }`}
            />
          </div>
          <div>
            <h3
              style={{
                fontFamily: "poppins",
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "-5px",
                marginLeft: "12px",
              }}
            >
              {receiver?.fullName?.charAt(0).toUpperCase() + receiver?.fullName?.slice(1)}
            </h3>
            <span className={styles.statusText}
              style={{
                fontSize: "13px",
                color: "#666",
                marginLeft: "12px",
                marginTop: "4px",
              }}
            >
              {activeStatus === "online" ? "Online" : "Offline"}
            </span>
          </div>
        </div>
        {currentUser?.role === TEACHER_ROLE && (
          <div className={styles.chatHeaderActions}>
            {!(isBlockedByMe || isBlocked) && (
              <>
              {meetingLoading ? (
                <Spin
                  indicator={antIcon}
                  size="small"
                  title="Create meeting..."
                />
              ) : (
              <BsCameraVideo
                title="Create zoom meeting"
                className={styles.headerIcon}
                onClick={() => createZoomMeeting()}
                size={20}
              />
            )}
            </>)}
          </div>
        )}
      </div>

      {/* Messages Area */}
      <div className={styles.messagesArea} ref={messagesAreaRef}>
        {loadingMoreMessages && (
          <div className={styles.loadingMore}>Loading...</div>
        )}

        {messages.length >= 10 && !loadingMoreMessages && (
          <div
            className={styles.loadMoreButton}
            onClick={() => loadMoreMessages(MESSAGE_LIMIT, messages)}
          >
            Load previous messages
          </div>
        )}

        {messages?.length ? (
          messages
            .slice()
            .reverse()
            ?.map((message, index) => {
              let hasZoomGuestUrl = checkZoomUrl(message);
              const formattedText = makeLinksClickable(
                hasZoomGuestUrl,
                message,
                currentUser?.role
              );
              const isSent = message.sender_uuid === currentUser?.uuid;
              const messageAvatar =  getReceiverAvatar(receiver, baseUrl);
              ["New Demo Request", "New Offer Request"].includes(
                formattedText
              ) && console.log("offer found", message?.offerDetail);
              return (
                <div
                  key={index}
                  className={`${styles.messageContainer} ${
                    isSent ? styles.sent : styles.received
                  }`}
                >
                  <div className={`d-flex align-items-start`}>
                    {!isSent && (
                      <div className={styles.messageAvatar}>
                        <Avatar
                          src={messageAvatar}
                          size={35}
                          style={{
                            marginLeft: isSent ? "8px" : "0",
                            marginRight: isSent ? "0" : "8px",
                            flexShrink: 0,
                          }}
                        />
                      </div>
                    )}

                    {/* Message Content */}
                    <div className={`d-flex flex-column ${isSent ? "align-items-end" : "align-items-start"}`}>
                        {message?.message_type === MESSAGE_TYPES.AUDIO ||
                        message?.message_type === "audio" ? (
                          <AudioPlayer
                            audioDuration={message?.audioDuration}
                            src={`${baseUrl}/${message?.audioUrl}`}
                            isSent={isSent}
                          />
                        ) : (
                          <div
                            className={`${
                              formattedText && formattedText?.indexOf("https://") !== -1
                                ? styles.meetingLink
                                : styles.messageContent
                            }`}
                            style={{
                              ...( ["New Demo Request", "New Offer Request"].includes(formattedText)
                                ? { borderTopLeftRadius: "18px", borderTopRightRadius: "18px", width:"100%" }
                                : { borderRadius: "18px" }
                              )
                            }}
                            dangerouslySetInnerHTML={{
                              __html: formatMessage(formattedText, 5),
                            }}
                          />
                        )}

                        <div ref={messagesEndRef} />

                        {message?.offerDetail && (
                          <StudentOfferCard
                            loading={offerStatusLoading}
                            currentUser={currentUser}
                            message={message}
                            updateOfferStatus={updateOfferStatus}
                            messageBgColor={isSent ? "#C8FAD6" : "#F4F6F8"}
                          />
                        )}

                      {/* Message Time and Status */}
                      <div className={styles.messageTime}>
                        {getFormatedMessageTime(message?.timestamp)}
                        {isSent && (
                          <span className={styles.messageStatus}>
                            <BiCheckDouble size={16} />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
        ) : initialLoading ? (
          <div className={styles.loadingMessages}>Loading messages...</div>
        ) : (
          <div className={styles.noMessages}>No messages to display</div>
        )}
      </div>

      {/* Input Area */}
      {!isBlocked && currentUser?.id ? (
        <div className={styles.inputArea}>
          <div className={styles.inputContainer}>
            {/* Audio recording controls */}
            {currentUser?.role === STUDENT_ROLE && (
              <div className={styles.offerActions}>
                <Popover
                  content={offerContent}
                  trigger="click"
                  open={offerPopupVisible}
                  onOpenChange={(visible) => setOfferPopupVisible(visible)}
                  placement="topLeft"
                  overlayClassName={styles.offerPopover}
                  className="p-0"
                >
                  <button className={styles.pinButton}>
                    <IoMdAttach size={20} title="Create Offer" />
                  </button>
                </Popover>
              </div>
            )}

            <input
              ref={inputRef}
              onKeyUp={(e) => {
                if (e.key === "Enter" && !loading && !initialLoading) {
                  sendMessage(newMessage, null, MESSAGE_TYPES.TEXT);
                }
              }}
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Type a message..."
              className={styles.messageInput}
            />
            <IoIosSend
              onClick={() => sendMessage(newMessage, null, MESSAGE_TYPES.TEXT)}
              className={styles.sendButton}
              size={40}
            />
          </div>

          <div
            className={styles.recordingControls}
            onClick={!isRecording ? startRecording : undefined} // Click container to start recording when not recording
          >
            {isRecording ? (
              <div className={styles.recordingButtons}>
                {isPaused ? (
                  <RiPlayFill
                    title="Resume recording"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent event bubbling
                      resumeRecording();
                    }}
                    color="#fff"
                    size={20}
                  />
                ) : (
                  <RiPauseFill
                    title="Pause recording"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent event bubbling
                      pauseRecording();
                    }}
                    size={20}
                    color="#fff"
                  />
                )}
                <RiVoiceprintFill
                  title="Stop recording and send"
                  className={
                    isRecording && !isPaused ? styles.recordingActive : ""
                  }
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    stopRecording();
                  }}
                  size={20}
                  color={isRecording && !isPaused ? "#ff4444" : "#fff"}
                />
                <BiTrash
                  title="Discard recording"
                  className={styles.discardButton}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    discardRecording();
                  }}
                  size={20}
                  color="#ff6b6b"
                />
              </div>
            ) : (
              <MdOutlineKeyboardVoice
                color="#fff"
                title="Start voice recording"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent event bubbling (though not needed here)
                  startRecording();
                }}
                size={20}
              />
            )}
          </div>
        </div>
      ) : !currentUser?.id ? (
        renderLoginMessage()
      ) : (
        renderBlockMessage() //render block messages here
      )}

      {/* {console.log("teacher id", currentUser, receiver)} */}
      {/* Offer card modal */}
      <CreateOfferCard
        handleChatModalOpen={handleChatModalOpen}
        setOfferDetail={setOfferDetail}
        offerDetail={offerDetail}
        teacherId={getTeacherId()}
        studentId={
          currentUser?.role === TEACHER_ROLE ? receiver.id : currentUser?.id
        }
        onSendOffer={sendOffer}
        handleOk={handleCreateOfferCardModal}
        handleCancel={handleCreateOfferCardModal}
        open={openOfferCard}
      />
    </div>
  );
};

export default Chat;
